import { ApplicationConfig, inject, provideZoneChangeDetection, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { provideRouter } from '@angular/router';
import { provideClientHydration } from '@angular/platform-browser';
import { HttpInterceptorFn, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { EMPTY } from 'rxjs';

import { routes } from './app.routes';
import { environment } from '../environments/environment';
import { AppService } from './shared/services/tabular/app.service';
import { DemoService } from './shared/services/tabular/demo.service';
import { RealService } from './shared/services/tabular/real.service';
import { OmicsService } from './shared/services/omics/omics.service';
import { OmicsDemoService } from './shared/services/omics/omics-demo.service';
import { OmicsRealService } from './shared/services/omics/omics-real.service';

const browserOnlyInterceptor: HttpInterceptorFn = (req, next) =>
  isPlatformBrowser(inject(PLATFORM_ID)) ? next(req) : EMPTY;

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(),
    provideHttpClient(withFetch(), withInterceptors([browserOnlyInterceptor])),
    // One switch, two contracts. `environment.demoMode` is the single decision;
    // each pipeline has its own abstract class because they share almost no
    // methods (different endpoint trees, and even separate session stores).
    // Components just inject the token they need and never learn which
    // implementation they got.
    {
      provide: AppService,
      useClass: environment.demoMode ? DemoService : RealService,
    },
    {
      provide: OmicsService,
      useClass: environment.demoMode ? OmicsDemoService : OmicsRealService,
    },
  ],
};
